import request from '@/middleware/request'

const getFlowTemplates = () => {
  return request({
    url: '/flow_template/list',
    method: 'get'
  })
}

const getFlowTemplateById = id => {
  return request({
    url: `/flow_template/${id}`,
    method: 'get'
  })
}

const createFlowTemplate = data => {
  return request({
    url: '/flow_template',
    method: 'post',
    data
  })
}

const renameFlowTemplate = (id, data) => {
  return request({
    url: `/flow_template/name/${id}`,
    method: 'patch',
    data
  })
}

const updateFlowTemplate = (id, data) => {
  return request({
    url: `/flow_template/${id}`,
    method: 'patch',
    data
  })
}

const deleteFlowTemplate = id => {
  return request({
    url: `/flow_template/${id}`,
    method: 'delete',
    data
  })
}

export default {
  getFlowTemplates,
  getFlowTemplateById,
  createFlowTemplate,
  renameFlowTemplate,
  updateFlowTemplate,
  deleteFlowTemplate
}
